import React, { useEffect, useState } from "react";
import { Button, Form, Input, InputNumber, Modal } from "antd";
import { assignMessage, errorMessage, successMessage } from '../../../utils/helpers'
import { ADMIN } from '../../../utils/apis'
import axios from "axios";

const InvitePointSetting = (props) => {
    const { user, edit, selectedLanguage, language } = props
    const [visible, setVisible] = useState(false)
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)
    const [refferalPoints, setRefferalPoints] = useState(null)


    const onFinish = (values) => {
        setLoading(true)
        values.adminId = user?._id
        refferalPoints?.point && (values._id = refferalPoints?._id)

        axios.post(refferalPoints?._id ? ADMIN?.EDIT_REFERRAL_POINTS : ADMIN?.ADD_REFERRAL_POINTS, values)
            .then((res) => {
                const { data } = res
                setLoading(false)
                if (data?.success) {
                    successMessage(assignMessage(data?.message, language?.language))
                    getRefferalPoint()
                }
                else {
                    errorMessage(assignMessage(data?.message, language?.language))
                }
            })
            .catch((e) => {
                setLoading(false)
                errorMessage(assignMessage(e?.message, language?.language))
            })
    }



    const handleOk = () => {
        setVisible(false)
    }

    const getRefferalPoint = () => {
        axios.get(ADMIN?.GET_REFERRAL_POINTS)
            .then((res) => {
                const { data } = res
                if (data?.success) {
                    setRefferalPoints(data?.data[0])
                }
                else {
                    setRefferalPoints(null)
                }
            })
            .catch((e) => {
                errorMessage(assignMessage(e?.message, language?.language))
            })

    }

    useEffect(() => {
        getRefferalPoint()
    }, [])

    return (
        <>
            <div className="reward-point-box">
                <p className="p-none-margin-bolder-p">{selectedLanguage?.text_WhenPlayerInviteHisFriendAndHeWillRegistered} </p>
                <p className="p-none-margin-bolder-p">
                    {selectedLanguage?.text_PlayerGet} ( {refferalPoints?.point || '--'} ) {selectedLanguage?.text_PointAsReward}</p>
                <div style={{ marginTop: '20px' }} className='button-div-flex-end'>
                    <Button
                        type="primary"
                        onClick={() => { setVisible(true) }}
                    >
                        {selectedLanguage?.text_UpdatePointSetting}
                    </Button>
                </div>
            </div>
            {/* --------Modal----- */}

            <Modal
                open={visible}
                onOk={handleOk}
                onCancel={handleOk}
                className='pop-info-modal'
                footer={null}>
                <div style={{ marginTop: '10px' }}>
                    <p className='p-question'> {selectedLanguage?.text_UpdateInviteRewardPoints}</p>
                    <div style={{ display: 'flex', flexDirection: 'column' }} className='form-div-in-modal'>
                        <Form
                            name='form'
                            form={form}
                            onFinish={onFinish}
                            layout={'vertical'}
                        >
                            <div className='form-two-input-flex-inner-input newInpuHeightFull' style={{ width: '100%' }}>
                                <Form.Item
                                    name='point'
                                    initialValue={refferalPoints?.point}
                                    hasFeedback
                                    label={<p className='p-admin-title-text'>{selectedLanguage?.text_RewardPoints}</p>}
                                    rules={[
                                        {
                                            required: true,
                                            message: selectedLanguage?.text_pleaseEnterPoint
                                        }
                                    ]}
                                >
                                    <Input
                                        // Number
                                        step={0.5}
                                        type='number'
                                        style={{ width: '100%' }}
                                        className='form-input-new-design-big-slam'
                                        placeholder={selectedLanguage?.text_EnterPointHere}
                                    />
                                </Form.Item>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', height: '40px', paddingRight: '5px' }}>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType='submit'
                                        loading={loading}
                                    >
                                        {refferalPoints?.point ? selectedLanguage?.text_UpdatePointSetting : selectedLanguage?.text_AddPointSetting}
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form>
                    </div>
                </div >
            </Modal >
        </>
    )
}



export default InvitePointSetting